module.exports = __webpack_public_path__ + "static/tsekine-eb5f4e685a6380d942e1e32b8be9bb7a.jpg";